import { IChartOfAccountListData } from '@modules/accounting-and-finance/interface/chart-of-accounts/chart-of-account-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IChartOfAccountListData[] = [];

export const ACCGChartOfAccountsSlice = createSlice({
  name: 'accgChartOfAccount',
  initialState,
  reducers: {
    setACCGChartOfAccount: (
      _state,
      action: PayloadAction<IChartOfAccountListData[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGChartOfAccount: () => {
      return initialState;
    },
  },
});

export default ACCGChartOfAccountsSlice.reducer;

export const { setACCGChartOfAccount, removeACCGChartOfAccount } =
  ACCGChartOfAccountsSlice.actions;
